'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal } from '@common/components';
import { SvgDelete } from '@common/icon';
import { cn } from '@core/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { SELECTOR } from '@/constants';
interface SessionPortalProps {
  renderTo: string | (() => HTMLElement | null);
  title?: string;
  onClose?: () => void;
  children: React.ReactNode;
  showHeader?: boolean;
  animationDuration?: number;
  className?: string;
  wrapperClassName?: string;
  stickyFooter?: React.ReactNode;
}
export const SessionPortal = t0 => {
  const $ = _c(43);
  const {
    renderTo,
    title,
    onClose,
    children,
    showHeader: t1,
    animationDuration: t2,
    className,
    wrapperClassName,
    stickyFooter
  } = t0;
  const showHeader = t1 === undefined ? true : t1;
  const animationDuration = t2 === undefined ? 0.1 : t2;
  let t3;
  if ($[0] !== renderTo) {
    t3 = typeof renderTo === "string" ? () => document.getElementById(renderTo) : renderTo;
    $[0] = renderTo;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const renderTarget = t3;
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0
    };
    t5 = {
      opacity: 1
    };
    t6 = {
      opacity: 0
    };
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== animationDuration) {
    t7 = {
      duration: animationDuration
    };
    $[5] = animationDuration;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== wrapperClassName) {
    t8 = cn("absolute left-0 top-0 z-10 flex size-full flex-col bg-Gray-white", wrapperClassName);
    $[7] = wrapperClassName;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== onClose || $[10] !== showHeader || $[11] !== title) {
    t9 = showHeader ? <div className={cn("sticky top-0 box-border flex min-h-56 w-full items-center justify-between bg-Gray-white px-20 text-center", "z-10 break-all font-600 text-Gray-900 typo-body3")}><div />{title}{onClose ? <SvgDelete role="button" className="size-20" onClick={onClose} aria-label={"\uB2EB\uAE30"} /> : null}</div> : null;
    $[9] = onClose;
    $[10] = showHeader;
    $[11] = title;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  let t11;
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      y: 5,
      opacity: 0
    };
    t11 = {
      y: 0,
      opacity: 1
    };
    t12 = {
      y: 5,
      opacity: 0
    };
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
  } else {
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
  }
  let t13;
  if ($[16] !== animationDuration) {
    t13 = {
      duration: animationDuration
    };
    $[16] = animationDuration;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  let t15;
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      opacity: 0,
      y: 5
    };
    t15 = {
      opacity: 1,
      y: 0
    };
    t16 = {
      opacity: 0,
      y: -5
    };
    $[18] = t14;
    $[19] = t15;
    $[20] = t16;
  } else {
    t14 = $[18];
    t15 = $[19];
    t16 = $[20];
  }
  let t17;
  if ($[21] !== animationDuration) {
    t17 = {
      duration: animationDuration
    };
    $[21] = animationDuration;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== className) {
    t18 = cn("h-fit w-full", className);
    $[23] = className;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== children || $[26] !== t17 || $[27] !== t18) {
    t19 = <AnimatePresence mode="wait"><motion.div initial={t14} animate={t15} exit={t16} transition={t17} className={t18}>{children}</motion.div></AnimatePresence>;
    $[25] = children;
    $[26] = t17;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t13 || $[30] !== t19) {
    t20 = <motion.div initial={t10} animate={t11} exit={t12} transition={t13} className="flex w-full flex-1 overflow-y-auto hide-scrollbar" id={SELECTOR.SESSION_PORTAL_CONTENT}>{t19}</motion.div>;
    $[29] = t13;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== stickyFooter) {
    t21 = <div className="flex w-full">{stickyFooter}</div>;
    $[32] = stickyFooter;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== t20 || $[35] !== t21 || $[36] !== t7 || $[37] !== t8 || $[38] !== t9) {
    t22 = <motion.div initial={t4} animate={t5} exit={t6} transition={t7} className={t8}>{t9}{t20}{t21}</motion.div>;
    $[34] = t20;
    $[35] = t21;
    $[36] = t7;
    $[37] = t8;
    $[38] = t9;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== renderTarget || $[41] !== t22) {
    t23 = <Portal renderTo={renderTarget}>{t22}</Portal>;
    $[40] = renderTarget;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  return t23;
};